import type { Outcome } from '@/api';

export function displayedOutcomeScore(o: Pick<Outcome, 'best_user_score' | 'user_score' | 'llm_score' | 'quality_score'>): number | undefined {
  if (o.best_user_score != null) return Math.round(o.best_user_score);
  if (o.user_score != null) return Math.round(o.user_score);
  if (o.llm_score != null) return Math.round(o.llm_score);
  if (o.quality_score != null) return o.quality_score;
  return undefined;
}

export function outcomeScores(outcomes: Outcome[]): Record<string, number> {
  const out: Record<string, number> = {};
  for (const o of outcomes) {
    const n = displayedOutcomeScore(o);
    if (n != null) out[o.id] = n;
  }
  return out;
}
